import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/navbar/Navbar";
import "./Home.css";

const Home = () => {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: "/Slide2526.jpg",
      title: t("home.welcome_title"),
      subtitle: t("home.festival_subtitle"),
      description: t("home.welcome_description"),
    },
    {
      id: 2,
      image: "/Slide2525.jpg",
      title: t("home.digital_governance_title"),
      subtitle: t("home.one_application_subtitle"),
      description: t("home.digital_governance_description"),
    },
    {
      id: 3,
      image: "/Slide2325.jpg",
      title: t("home.building_communities_title"),
      subtitle: t("home.celebrate_festivals_subtitle"),
      description: t("home.building_communities_description"),
    },
  ];

  const civicServices = [
    {
      id: 1,
      title: t("home.mandap_application"),
      description: t("home.mandap_description"),
      icon: "/mandap.png",
      link: "/mandapapplication",
      color: "bg-gradient-primary",
      buttonText: t("home.apply_now"),
    },
    {
      id: 2,
      title: t("home.murtikar_title"),
      description: t("home.murtikar_description"),
      icon: "/Stockist.png",
      link: "/murticarform",
      color: "bg-gradient-success",
      buttonText: t("home.apply_now"),
    },
    {
      id: 3,
      title: t("home.track_application_title"),
      description: t("home.track_description"),
      icon: "/track.png",
      link: "/trackapplication",
      color: "bg-gradient-info",
      buttonText: t("home.check_status"),
    },
    {
      id: 4,
      title: t("home.downloads_title"),
      description: t("home.downloads_description"),
      icon: "/download.png",
      link: "/download",
      color: "bg-gradient-warning",
      buttonText: t("home.view_documents"),
    },
  ];

  const faqs = [
    {
      id: 1,
      question: t("home.faq_1_question"),
      answer: t("home.faq_1_answer"),
    },
    {
      id: 2,
      question: t("home.faq_2_question"),
      answer: t("home.faq_2_answer"),
    },
    {
      id: 3,
      question: t("home.faq_3_question"),
      answer: t("home.faq_3_answer"),
    },
    {
      id: 4,
      question: t("home.faq_4_question"),
      answer: t("home.faq_4_answer"),
    },
    {
      id: 5,
      question: t("home.faq_5_question"),
      answer: t("home.faq_5_answer"),
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-in");
        }
      });
    }, observerOptions);

    document.querySelectorAll(".animate-on-scroll").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="home-page">
      {/* Hero Slider */}
      <section className="hero-slider">
        <div className="slider-container">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`slide ${index === currentSlide ? "active" : ""}`}
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="slide-overlay"></div>
              {/* फक्त शेवटच्या slide शिवाय content दाखवायचा */}
              {slide.id !== 4 && (
                <div className="slide-content">
                  <div className="container">
                    <div className="row justify-content-center text-center">
                      <div className="col-lg-8">
                        <h1 className="slide-title">{slide.title}</h1>
                        <h3 className="slide-subtitle">{slide.subtitle}</h3>
                        <p className="slide-description">{slide.description}</p>

                        <p>

सन 2025 मध्ये परवानगी मिळालेल्या अहिल्यानगर महानगरपालिकेतील 272 सार्वजनिक गणेशोत्सव मंडळांना नमूद अटी-शर्तींच्या अधीन राहून गणेशोत्सव 2029 पर्यंत मंडप परवानगीस प्रशासकीय स्वरूपात मुदतवाढ देण्यात आली आहे.
</p>
                        <div className="slide-actions d-flex flex-wrap justify-content-center gap-3">
                          <NavLink
                            to="/mandapapplication"
                            className="btn btn-primary btn-lg"
                          >
                            {t("home.get_started")}
                          </NavLink>
                          <NavLink
                            to="/trackapplication"
                            className="btn btn-outline-light btn-lg"
                          >
                            {t("home.track_application")}
                          </NavLink>
                          <a
                            href="/ganeshotsav_2026.pdf"
                            download="गणेशोत्सव 2026.pdf"
                            className="btn btn-warning btn-lg fw-bold d-inline-flex align-items-center"
                          >
                            <i className="fas fa-download me-2"></i> गणेशोत्सव २०२६ PDF डाउनलोड
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
          
          <button className="slider-btn prev-btn" onClick={prevSlide}>
            <i className="fas fa-chevron-left"></i>
          </button>
          <button className="slider-btn next-btn" onClick={nextSlide}>
            <i className="fas fa-chevron-right"></i>
          </button>

          <div className="slider-indicators">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentSlide ? "active" : ""
                  }`}
                onClick={() => setCurrentSlide(index)}
              ></button>
            ))}
          </div>
        </div>
      </section>
      {/* Horizontal Announcement Ticker */}
      <section className="announcement-ticker-section">
        <div className="container-fluid px-0">
          <div className="announcement-ticker-wrapper">
            <div className="ticker-label">
              <span className="ticker-badge">
                <i className="fas fa-bullhorn me-1"></i> नवीन घोषणा
              </span>
            </div>
            <div className="ticker-content">
              <div className="ticker-track">
                <span className="ticker-item">
                  <i className="fas fa-star text-warning me-2"></i>
                  <strong>गणेशोत्सव २०२६ :</strong> उत्सव नियोजन, मंडप व स्टॉल परवानगी नियमावली प्रसिद्ध करण्यात आली आहे.
                  <a
                    href="/ganeshotsav_2026.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ticker-btn view ms-2"
                  >
                    <i className="fas fa-eye me-1"></i> पहा (View)
                  </a>
                  <a
                    href="/ganeshotsav_2026.pdf"
                    download="गणेशोत्सव 2026.pdf"
                    className="ticker-btn download ms-2"
                  >
                    <i className="fas fa-download me-1"></i> डाउनलोड (Download)
                  </a>
                </span>
                <span className="ticker-item">
                  <i className="fas fa-circle-info text-info me-2"></i>
                  सर्व मंडप व मूर्तिकार धारकांनी अधिकृत नियमावली वाचून तात्काळ ऑनलाइन अर्ज नोंदणी करावी.
                </span>
                <span className="ticker-item">
                  <i className="fas fa-star text-warning me-2"></i>
                  <strong>गणेशोत्सव २०२६ :</strong> उत्सव नियोजन, मंडप व स्टॉल परवानगी नियमावली प्रसिद्ध करण्यात आली आहे.
                  <a
                    href="/ganeshotsav_2026.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ticker-btn view ms-2"
                  >
                    <i className="fas fa-eye me-1"></i> पहा (View)
                  </a>
                  <a
                    href="/ganeshotsav_2026.pdf"
                    download="गणेशोत्सव 2026.pdf"
                    className="ticker-btn download ms-2"
                  >
                    <i className="fas fa-download me-1"></i> डाउनलोड (Download)
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Upcoming Event & Notice Section */}



      {/* Civic Services Section */}
      <section className="civic-services py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5 animate-on-scroll">
              <h2 className="section-title">{t("home.our_civic_services")}</h2>
              <p className="section-subtitle">
                {t("home.civic_services_subtitle")}
              </p>
              <div className="title-divider"></div>
            </div>
          </div>
          <div className="row g-4">
            {civicServices.map((service, index) => (
              <div
                key={service.id}
                className="col-lg-3 col-md-6 animate-on-scroll"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div
                  className={`card h-100 border-0 shadow-sm service-item ${service.color} position-relative`}
                >
                  <div className="card-body text-center p-4 d-flex flex-column">
                    <div className="service-icon mb-3">
                      <img
                        src={service.icon}
                        alt={service.title}
                        className="img-fluid"
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <h4 className="card-title text-white mb-3">
                      {service.title}
                    </h4>
                    <p className="card-text text-white-50 flex-grow-1">
                      {service.description}
                    </p>
                    <div className="mt-auto d-flex justify-content-center">
                      <NavLink to={service.link} className="service-btn">
                        <span className="btn-text">{service.buttonText}</span>
                        <span className="btn-arrow">
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section py-5 bg-light">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0 animate-on-scroll">
              <div className="about-image-wrapper">
                <img
                  src="/about.jpg"
                  alt="Ahilyanagar Municipal Corporation"
                  className="img-fluid rounded-3 shadow-lg about-image"
                />
                <div className="about-image-overlay"></div>
              </div>
            </div>
            <div className="col-lg-6 animate-on-scroll">
              <div className="about-content">
                <h2 className="about-title mb-4">{t("home.about_title")}</h2>
                <p className="about-text mb-4" style={{ textAlign: "justify" }}>
                  {t("home.about_text_1")}
                </p>
                <p className="about-text mb-4" style={{ textAlign: "justify" }}>
                  {t("home.about_text_2")}
                </p>
                <p className="about-text mb-4" style={{ textAlign: "justify" }}>
                  {t("home.about_text_3")}
                </p>
                <div className="about-stats row">
                  <div className="col-4 text-center">
                    <div className="stat-number">2K+</div>
                    <div className="stat-label">
                      {t("home.applications_processed")}
                    </div>
                  </div>
                  <div className="col-4 text-center">
                    <div className="stat-number">24/7</div>
                    <div className="stat-label">{t("home.online_support")}</div>
                  </div>
                  <div className="col-4 text-center">
                    <div className="stat-number">99%</div>
                    <div className="stat-label">
                      {t("home.satisfaction_rate")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="civic-banner-section py-0">
        <div className="container-fluid px-0">
          <div className="row g-0">
            <div className="col-12">
              <div className="civic-banner-wrapper animate-on-scroll">
                <img
                  src="/slider0809.png"
                  alt="Ahilyanagar Municipal Corporation Infrastructure"
                  className="img-fluid civic-banner-image w-100"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="faq-section py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5 animate-on-scroll">
              <h2 className="section-title">{t("home.faq_title")}</h2>
              <p className="section-subtitle">{t("home.faq_subtitle")}</p>
              <div className="title-divider"></div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="accordion animate-on-scroll" id="faqAccordion">
                {faqs.map((faq, index) => (
                  <div
                    key={faq.id}
                    className="accordion-item mb-3 border-0 shadow-sm"
                  >
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${faq.id}`}
                        aria-expanded="false"
                        aria-controls={`collapse${faq.id}`}
                      >
                        <span className="faq-number me-3">
                          {String(index + 1).padStart(2, "0")}
                        </span>
                        {faq.question}
                      </button>
                    </h2>
                    <div
                      id={`collapse${faq.id}`}
                      className="accordion-collapse collapse"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">{faq.answer}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer bg-dark text-white pt-5 pb-3">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="footer-brand mb-4">
                <img
                  src="/logo1.jpeg"
                  alt="Logo"
                  className="footer-logo mb-3"
                />
                <h5>Ahilyanagar Municipal Corporation</h5>
                <p>अहिल्यानगर महानगर पालिका</p>
              </div>
              <p className="footer-description">
                {t("home.footer_description")}
              </p>
              <div className="social-links">
                <a
                  href="https://www.facebook.com/ahmednagar.prasiddhi.7/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook"></i>
                </a>
                <a
                  href="https://www.instagram.com/amcnagar/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href="https://www.facebook.com/ahmednagar.prasiddhi.7/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 mb-4">
              <h6 className="footer-title">{t("home.quick_links")}</h6>
              <ul className="footer-links">
                <li>
                  <NavLink to="/">{t("navbar.Home")}</NavLink>
                </li>
                <li>
                  <NavLink to="/mandapapplication">
                    {t("home.festival_applications")}
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/murticarform">
                    {t("home.murtikar_title")}
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/trackapplication">
                    {t("navbar.Track Status")}
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/download">{t("navbar.DownLoad")}</NavLink>
                </li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 mb-4">
              <h6 className="footer-title">{t("home.contact_info")}</h6>
              <div className="contact-info">
                <div className="contact-item mb-2">
                  <i className="fas fa-map-marker-alt me-2"></i>
                  <span>Ahilyanagar Municipal Corporation, Maharashtra</span>
                </div>
                <div className="contact-item mb-2">
                  <i className="fas fa-phone me-2"></i>
                  <a href="#">+2343622, 2340522</a>
                </div>
                <div className="contact-item mb-2">
                  <i className="fas fa-envelope me-2"></i>
                  <a href="mailto:it.nagar@amc.gov.in">it.nagar@amc.gov.in</a>
                </div>
                <div className="contact-item">
                  <i className="fas fa-clock me-2"></i>
                  <span>Mon - Fri: 9:00 AM - 5:00 PM</span>
                </div>
              </div>
            </div>
          </div>

          <hr className="footer-divider" />

          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="copyright mb-0">{t("home.copyright")}</p>
            </div>
            <div className="col-md-6 text-md-end">
              <div className="footer-bottom-links">
                <a href="#">{t("home.privacy_policy")}</a>
                <a href="#">{t("home.terms_of_service")}</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
